<ng-container *ngIf='articoli; else waiting'>
<div class="row" style="margin-top: 20px;">
    <div class="form-group col-4" >
        <label class="roboSubTitle" for="environment">{{ 'configuration.articoli.search' | translate }} </label>
        <div class="input-group mb-3" >
            <input #src type="text" class="form-control" [placeholder]="'placeholder.search' | translate" aria-label="Cerca per nome"  aria-describedby="basic-addon1" (keyup.enter)="search(src.value)">
            <span class="input-group-text" id="basic-addon1" (click)="search(src.value)"><i class="bi bi-search" [ngbTooltip]="'tooltip.search' | translate"></i></span>
        </div>
    </div>
    
</div>
<div>
    <table class="table" >
      <thead>
        <tr >
          <th scope="col"  style="cursor: pointer;">{{'configuration.articoli.desc' | translate}}</th> 
          <th scope="col">{{'configuration.articoli.unit' | translate}}</th>
          <th scope="col">{{'configuration.articoli.price' | translate}}</th>
          <th scope="col">{{'configuration.articoli.aliq' | translate}}</th>
          <th scope="col">{{'configuration.articoli.nat' | translate}}</th>
          <th scope="col" style='text-align: right;'> 
            <button type="button" class="btn btn-light" (click)="refresh()" style="margin-right: 20px"><i class="bi bi-arrow-clockwise"></i></button>
            <button type="button" class="btn btn-light" (click)='addItem()'><i class="bi bi-plus"></i> {{ 'general.add' | translate }}</button> </th>
        </tr>
      </thead> 
      <tbody>
        <tr *ngFor="let u of articoli" >
          <td>
            <input type="text" class="form-control" [(ngModel)]="u.item.descrizione" [disabled]='!u.modify '>
          </td>
          <td>
            <input type="text" class="form-control" [(ngModel)]="u.item.unitadimisura" [disabled]='!u.modify '>
          </td>
          <td>
            <input type="number" class="form-control" [(ngModel)]="u.item.prezzounitario" [disabled]='!u.modify '>
          </td>
          <td>
            <input type="number" *ngIf='!u.modify || u.item.natura!=""' class="form-control" [(ngModel)]="u.item.aliquotaiva" [disabled]='!u.modify || u.item.natura!=""' [value]="(u.item.natura.length>0? 0 : u.item.aliquotaiva)" >
            <div *ngIf='u.item.natura=="" && u.modify' class="dm7Select" >
                <div class="select-side">
                  <img src="assets/icone_varie/arrow_down.svg">
                </div>
                <!--(change)='u.item.natura = u.item.aliquotaIva>0? "" : u.item.natura'-->
                <app-select class="selectDm7" 
                        [options]="listAliquote" [key]="'val'" [value]="'label'" [addNull]='true'
                        [placeholder]="'placeholder.select' | translate" [selectedKey]="u.item.aliquotaiva"
                        (change)="u.item.aliquotaiva= $event.key;"></app-select>
            </div>
          </td>
          <td>
              <!-- QUI CI VA LA SELECT -->
            <input *ngIf='!u.modify || u.item.aliquotaiva>0' type="text" class="form-control" [disabled]='u.item.aliquotaiva>0 || !u.modify' [placeholder]='getPlaceholder(u.item.natura!)'>
            <div *ngIf='u.item.aliquotaiva<=0 && u.modify' class="dm7Select" >
                <div class="select-side">
                  <img src="assets/icone_varie/arrow_down.svg">
                </div>
                <app-select class="selectDm7" 
                        [options]="listIVA" [key]="'val'" [value]="'label'" [addNull]='true'
                        [placeholder]="'placeholder.select' | translate" [selectedKey]="u.item.natura"
                        (change)="u.item.natura= $event.key; u.item.aliquotaiva=0"></app-select>
            </div>
          </td>
          <td >
            <button *ngIf='!u.modify' type="button" class="btn btn-light" (click)="modifyItem(u)" style='margin-right: 10px'><i class="bi bi-pencil-square"></i></button>
            <button *ngIf='u.modify' type="submit" class="btn btn-light" style="margin-right: 10px;" (click)='save(u)'>{{ 'general.save' | translate }}</button>
            <button type="button" class="btn btn-light" (click)="deleteItem(u)"><i class="bi bi-trash"></i></button>
          </td>
          
        </tr>
      </tbody>
    </table>
  </div>
  <ng-container *ngIf='articoli.length==0'>
    <div>
      <ngb-toast [autohide]="false" class="warning">
          <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
          {{'general.noResults' | translate}}
      </ngb-toast>
    </div>
  </ng-container>
</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>